import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconMotorBoard: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        xmlns: 'http://www.w3.org/2000/svg',
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M11.9 9H10c-.4 0-.7-.2-.9-.6-.2-.3-.1-.7.1-1.1l2.5-3c.3-.4 1-.5 1.4-.1.4.3.5 1 .1 1.4L12.1 7H14c.4 0 .7.2.9.5.2.4.1.8-.1 1.1l-2.5 3c-.2.3-.5.4-.8.4-.2 0-.5-.1-.6-.2-.5-.4-.5-1-.2-1.4L11.9 9zm9.1 3c.6 0 1 .4 1 1 0 1.6-1.2 2.9-2.8 3 .5.5.8 1.2.8 2 0 1.7-1.3 3-3 3s-3-1.3-3-3c0-.8.3-1.5.8-2H9.2c.5.5.8 1.2.8 2 0 1.7-1.3 3-3 3s-3-1.3-3-3c0-.8.3-1.5.8-2-1.6-.1-2.8-1.4-2.8-3 0-.6.4-1 1-1s1 .4 1 1 .4 1 1 1h14c.6 0 1-.4 1-1s.4-1 1-1zM6 18c0 .6.4 1 1 1s1-.4 1-1-.4-1-1-1-1 .4-1 1zm10 0c0 .6.4 1 1 1s1-.4 1-1-.4-1-1-1-1 .4-1 1z',
      fillRule: 'evenodd',
      clipRule: 'evenodd',
    })
  )
}
